import script from "./Stock.vue?vue&type=script&setup=true&lang=js"
export * from "./Stock.vue?vue&type=script&setup=true&lang=js"

import "./Stock.vue?vue&type=style&index=0&id=2df5a7af&lang=scss"

const __exports__ = script;

export default __exports__